/* ==========================================================================
   SMJ B2B storefront behaviors
   Additive only: reads the same CartJS cart the existing validation uses.
   All existing order validation in theme.liquid keeps running untouched.
   window.smjB2B is set by snippets/smj-customer-banner.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function cfg() {
    return window.smjB2B || {};
  }

  function mixed20ftCapacity() {
    var mode = (cfg().additionalOrderModes || []).find(function (item) {
      return item.key === 'mixed_1l_20ft';
    });
    return mode ? Number(mode.container_capacity) : 1135;
  }

  var DEFAULT_SATEX_SCENARIOS = [
    { key: 'max_1l', label: 'Max 1L', oneLitreCases: 2000, twoHundredMlCases: 72 },
    { key: 'balanced', label: 'Balanced', oneLitreCases: 1500, twoHundredMlCases: 1300 },
    { key: 'mid_mix', label: 'Mid Mix', oneLitreCases: 1000, twoHundredMlCases: 2527 },
    { key: 'heavy_200ml', label: 'Heavy 200ml', oneLitreCases: 500, twoHundredMlCases: 3754 },
    { key: 'max_200ml', label: 'Max 200ml', oneLitreCases: 100, twoHundredMlCases: 4736 }
  ];

  function satexScenarios() {
    var configured = cfg().satexScenarios;
    return Array.isArray(configured) && configured.length
      ? configured
      : DEFAULT_SATEX_SCENARIOS;
  }

  function satexScenarioByKey(key) {
    var normalized = String(key || '').trim().toLowerCase();
    return satexScenarios().find(function (scenario) {
      return scenario.key === normalized;
    }) || null;
  }

  function satexScenarioTotal(scenario) {
    if (!scenario) return 0;
    return Number(scenario.oneLitreCases || 0) +
      Number(scenario.twoHundredMlCases || 0);
  }

  function normalizedProductText(value) {
    return String(value || '').toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function compactProductText(value) {
    return normalizedProductText(value).replace(/\s+/g, '');
  }

  function isSatexTetraProduct(productTitle, variantTitle) {
    var product = normalizedProductText(productTitle);
    var variant = compactProductText(variantTitle);
    var oneLitre = variant.indexOf('1l') !== -1 ||
      variant.indexOf('1000ml') !== -1;
    var twoHundredMl = variant.indexOf('200ml') !== -1;

    if (
      (product.indexOf('fruta premium') !== -1 ||
        product.indexOf('fruta tetra') !== -1) &&
      (oneLitre || twoHundredMl)
    ) {
      return true;
    }
    return twoHundredMl && (
      product.indexOf('fruta kids') !== -1 ||
      product.indexOf('fruta kidz') !== -1 ||
      product.indexOf('kool kidz') !== -1 ||
      product.indexOf('kool kids') !== -1
    );
  }


  /* Profiles exempt from top-load may still force it for named families
     (window.smjB2B.topLoadForcedFamilies). TGG: Fruta Premium 475ml only. */
  function forcedTopLoadFamily(productTitle, variantTitle) {
    var families = cfg().topLoadForcedFamilies ||
      window.smj_top_load_forced_families || [];
    if (!families.length) return false;
    var product = normalizedProductText(productTitle);
    var variant = compactProductText(variantTitle);
    var is475 = ['475ml', '500ml', '520ml', '17oz'].some(function (size) {
      return variant.indexOf(size) !== -1;
    });
    return families.some(function (key) {
      return key === 'fruta_premium_475' && is475 &&
        product.indexOf('fruta premium') !== -1;
    });
  }

  function productNeedsTopLoad(productTitle, variantTitle) {
    if (
      (cfg().topLoadExempt || window.smj_top_load_exempt) &&
      !forcedTopLoadFamily(productTitle, variantTitle)
    ) return false;
    var product = normalizedProductText(productTitle);
    var variant = compactProductText(variantTitle);
    var oneLitre = variant.indexOf('1l') !== -1 ||
      variant.indexOf('1000ml') !== -1;
    var onePointFiveLitre = variant.indexOf('15l') !== -1 ||
      variant.indexOf('1500ml') !== -1;
    var changed475Size = [
      '475ml',
      '500ml',
      '520ml',
      '17oz'
    ].some(function (size) {
      return variant.indexOf(size) !== -1;
    });
    var isTrinidadJuice = product.indexOf('trinidad juice') !== -1 ||
      (
        product.indexOf('trinidad') !== -1 &&
        product.indexOf('reconstituted juice') !== -1
      );

    if (
      oneLitre &&
      (
        product.indexOf('fruta premium') !== -1 ||
        product.indexOf('fruta tetra') !== -1 ||
        isTrinidadJuice
      )
    ) {
      return true;
    }
    if (
      onePointFiveLitre &&
      product.indexOf('oasis purified water') !== -1
    ) {
      return true;
    }
    return changed475Size && (
      product.indexOf('caribbean cool') !== -1 ||
      product.indexOf('fruta premium') !== -1 ||
      product.indexOf('fruta max') !== -1 ||
      product.indexOf('altitude') !== -1
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var format = cfg().moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
  }
  function formatCount(value) {
    if (!isFinite(value)) return '0';
    var rounded = Math.round(value * 100) / 100;
    return rounded % 1 === 0
      ? String(Math.round(rounded))
      : rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  }

  /* ---------- cart math (mirrors the counting rules in theme.liquid) ---------- */
  function summarizeCart(cart) {
    var profile = cfg().profile || 'standard';
    var capacity = cfg().capacity || 21;
    var summary = {
      profile: profile,
      mode: 'pallets',
      capacity: capacity,
      palletLimit: cfg().palletLimit || capacity,
      unit: cfg().unit || 'pallets',
      pallets: 0,
      cases: 0,
      containers: 0,
      satexMixedWithPallets: false,
      satexOneLitreCases: 0,
      satexTwoHundredMlCases: 0,
      satexUnknownCases: 0,
      satexScenarioKey: '',
      satexScenario: null,
      satexScenarioConflict: false,
      satexScenarioComplete: false,
      satexTargetCases: 0,
      mixed20ftCases: 0,
      mixed20ftMixedWithOtherItems: false,
      mixed20ftComplete: false,
      totalPrice: cart.total_price || 0,
      itemCount: cart.item_count || 0
    };
    if (!cart.items) return summary;

    var pairedGroups = {};
    var satexCases = 0;
    var satexScenarioKeys = {};
    cart.items.forEach(function (item) {
      var title = String(item.title || '').toLowerCase();
      var props = item.properties || {};
      var lineProfile = props._smj_order_profile || '';
      var uniqueId = props._unique_id;
      var isCase = /\bcases?\b/.test(title);

      if (lineProfile === 'satex_case_2500') {
        var satexQuantity = Number(item.quantity || 0);
        var satexCategory = String(props._smj_satex_category || '');
        var satexScenarioKey = String(props._smj_satex_scenario || '');
        satexCases += satexQuantity;
        if (satexCategory === 'one_litre') {
          summary.satexOneLitreCases += satexQuantity;
        } else if (satexCategory === 'two_hundred_ml') {
          summary.satexTwoHundredMlCases += satexQuantity;
        } else {
          summary.satexUnknownCases += satexQuantity;
        }
        if (satexScenarioKey) satexScenarioKeys[satexScenarioKey] = true;
        return;
      }

      if (lineProfile === 'mixed_1l_20ft') {
        summary.mixed20ftCases += Number(item.quantity || 0);
        return;
      }

      if (lineProfile === 'top_load_pair') {
        var pairKey = uniqueId || ('unpaired-' + item.key);
        if (!pairedGroups[pairKey]) {
          pairedGroups[pairKey] = { quantity: 0, cases: 0 };
        }
        pairedGroups[pairKey].quantity = Math.max(
          pairedGroups[pairKey].quantity,
          item.quantity || 0
        );
        pairedGroups[pairKey].cases +=
          (parseInt(props._smj_top_load_cases, 10) || 0) * (item.quantity || 0);
        return;
      }

      if (
        profile === 'case_pallet_22' &&
        (lineProfile === 'case_pallet_22' || props._smj_case_order === 'true')
      ) {
        var cpp = parseInt(props._smj_cases_per_pallet, 10) || 1;
        summary.cases += item.quantity;
        summary.pallets += Math.ceil(item.quantity / cpp);
        return;
      }

      if (uniqueId) {
        if (!pairedGroups[uniqueId]) {
          pairedGroups[uniqueId] = { quantity: 0, cases: 0 };
        }
        pairedGroups[uniqueId].quantity = Math.max(
          pairedGroups[uniqueId].quantity,
          item.quantity || 0
        );
      } else if (!isCase) {
        summary.pallets += item.quantity;
      } else {
        summary.pallets += Math.ceil(item.quantity / 2);
      }
    });

    Object.keys(pairedGroups).forEach(function (groupId) {
      summary.pallets += pairedGroups[groupId].quantity;
      summary.cases += pairedGroups[groupId].cases;
    });

    if (summary.mixed20ftCases > 0) {
      summary.mode = 'mixed_1l_20ft';
      summary.cases = summary.mixed20ftCases;
      summary.capacity = mixed20ftCapacity();
      summary.unit = 'cases';
      summary.containers = summary.cases / summary.capacity;
      summary.mixed20ftComplete = summary.cases === summary.capacity;
      summary.mixed20ftMixedWithOtherItems = summary.pallets > 0 || satexCases > 0;
      return summary;
    }

    if (profile === 'satex_case_2500' && satexCases > 0) {
      var scenarioKeys = Object.keys(satexScenarioKeys);
      var selectedScenario = scenarioKeys.length === 1
        ? satexScenarioByKey(scenarioKeys[0])
        : null;
      summary.mode = 'satex_cases';
      summary.cases = satexCases;
      summary.satexScenarioConflict = scenarioKeys.length > 1;
      summary.satexScenarioKey = selectedScenario ? selectedScenario.key : '';
      summary.satexScenario = selectedScenario;
      summary.satexTargetCases = satexScenarioTotal(selectedScenario);
      summary.satexScenarioComplete = !!(
        selectedScenario &&
        !summary.satexUnknownCases &&
        summary.satexOneLitreCases === Number(selectedScenario.oneLitreCases) &&
        summary.satexTwoHundredMlCases === Number(selectedScenario.twoHundredMlCases)
      );
      summary.containers = summary.satexTargetCases
        ? satexCases / summary.satexTargetCases
        : 0;
      summary.satexMixedWithPallets = summary.pallets > 0;
      return summary;
    }

    if (profile === 'satex_case_2500') {
      summary.capacity = 21;
      summary.unit = 'pallets';
    }
    summary.containers = summary.pallets / capacity;
    if (summary.capacity !== capacity) {
      summary.containers = summary.pallets / summary.capacity;
    }
    return summary;
  }

  function cartRuleErrors(cart, summary) {
    var errors = [];
    var topLoadGroups = {};
    var hasUnconfiguredTopLoad = false;
    var hasUnconfiguredSatexTetra = false;

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var lineProfile = props._smj_order_profile || '';
      var productTitle = item.product_title || item.title || '';
      var variantTitle = item.variant_title || item.title || '';
      var isSatexTetra = (
        summary.profile === 'satex_case_2500' &&
        isSatexTetraProduct(productTitle, variantTitle)
      );

      if (lineProfile === 'mixed_1l_20ft') {
        if (
          String(props._smj_order_unit || '') !== 'cases' ||
          String(props._smj_container_capacity || '') !== String(mixed20ftCapacity()) ||
          !String(props._smj_original_sku || '')
        ) {
          errors.push(item.title + ': rebuild this line in the 20ft container planner.');
        }
        return;
      }

      if (isSatexTetra) {
        if (lineProfile !== 'satex_case_2500') {
          hasUnconfiguredSatexTetra = true;
        }
      } else if (
        productNeedsTopLoad(productTitle, variantTitle) &&
        lineProfile !== 'top_load_pair'
      ) {
        hasUnconfiguredTopLoad = true;
      }
      if (lineProfile === 'top_load_pair') {
        var uniqueId = props._unique_id || '';
        if (!topLoadGroups[uniqueId]) topLoadGroups[uniqueId] = [];
        topLoadGroups[uniqueId].push({
          role: props._smj_top_load_role || '',
          group: props._smj_top_load_group || '',
          quantity: item.quantity || 0
        });
      }
      if (
        summary.profile === 'case_pallet_22' &&
        lineProfile !== 'top_load_pair' &&
        (lineProfile === 'case_pallet_22' || props._smj_case_order === 'true')
      ) {
        var cpp = parseInt(props._smj_cases_per_pallet, 10) || 1;
        if (cpp > 1 && item.quantity % cpp !== 0) {
          errors.push(item.title + ': order in multiples of ' + cpp + ' cases.');
        }
      }
    });

    if (hasUnconfiguredTopLoad) {
      errors.push(
        'One or more products require an approved top-loaded pallet. Remove them and use Configure top-loaded pallet.'
      );
    }
    if (hasUnconfiguredSatexTetra) {
      errors.push(
        'Satex tetra products must be added through the container planner.'
      );
    }

    Object.keys(topLoadGroups).forEach(function (uniqueId) {
      var lines = topLoadGroups[uniqueId];
      var roles = lines.map(function (line) { return line.role; }).sort().join('|');
      var groups = lines.map(function (line) { return line.group; });
      var quantities = lines.map(function (line) { return line.quantity; });
      if (
        !uniqueId ||
        lines.length !== 2 ||
        roles !== 'base|main' ||
        !groups[0] ||
        groups[0] !== groups[1] ||
        quantities[0] !== quantities[1]
      ) {
        errors.push('A top-loaded pallet pair is incomplete. Remove it and configure the pallet again.');
      }
    });

    if (summary.mode === 'mixed_1l_20ft') {
      if (summary.mixed20ftMixedWithOtherItems) {
        errors.push('The 20ft 1L container must be submitted as a separate order.');
      }
      if (!summary.mixed20ftComplete) {
        errors.push(
          'The 20ft 1L container must total exactly ' + mixed20ftCapacity().toLocaleString() + ' cases. Current total: ' +
          summary.cases.toLocaleString() + ' cases.'
        );
      }
    } else if (summary.mode === 'satex_cases') {
      if (summary.satexScenarioConflict) {
        errors.push('All Satex tetra items must use the same approved container scenario.');
      } else if (!summary.satexScenario) {
        errors.push('Build Satex tetra orders in the container planner and select an approved scenario.');
      } else if (summary.satexUnknownCases) {
        errors.push('One or more Satex tetra lines are missing their 1L or 200ml category. Rebuild the container.');
      } else if (!summary.satexScenarioComplete) {
        errors.push(
          summary.satexScenario.label + ' requires exactly ' +
          Number(summary.satexScenario.oneLitreCases).toLocaleString() +
          ' 1L cases and ' +
          Number(summary.satexScenario.twoHundredMlCases).toLocaleString() +
          ' 200ml cases.'
        );
      }
      if (summary.satexMixedWithPallets) {
        errors.push('Pallet products must be submitted in a separate order.');
      }
    } else if (
      summary.profile !== 'case_pallet_22' &&
      summary.pallets > summary.palletLimit
    ) {
      errors.push('This account can order up to ' + summary.palletLimit + ' pallets per order.');
    }
    return errors;
  }

  function renderDrawerSummary(summary, errors) {
    document.querySelectorAll(
      '.tgg-cart-summary, .smj-standard-cart-summary, .smj-order-rule-summary'
    ).forEach(function (element) {
      element.remove();
    });
    if (!summary.itemCount) return;

    var host = document.querySelector('.cart-drawer-custom-fields .smj-cart-summary-anchor');
    if (!host) return;
    var equation = '';
    if (summary.mode === 'mixed_1l_20ft') {
      equation = summary.cases.toLocaleString() + ' cases = ' +
        formatCount(summary.containers) + ' × 20ft container';
    } else if (summary.mode === 'satex_cases') {
      equation =
        summary.satexOneLitreCases.toLocaleString() + ' 1L + ' +
        summary.satexTwoHundredMlCases.toLocaleString() + ' 200ml = ' +
        summary.cases.toLocaleString() + ' cases';
    } else {
      equation = (
        summary.cases > 0 ? summary.cases.toLocaleString() + ' cases = ' : ''
      ) + summary.pallets.toLocaleString() + ' pallets = ' +
        formatCount(summary.containers) + ' containers';
    }
    host.innerHTML =
      '<div class="smj-order-rule-summary ' + (errors.length ? 'is-invalid' : 'is-valid') + '">' +
        '<strong>Container summary</strong>' +
        '<span>' + equation + '</span>' +
        '<small>' + (
          summary.mode === 'mixed_1l_20ft'
            ? 'Exactly ' + mixed20ftCapacity().toLocaleString() + ' eligible 1L cases = one submitted container'
            : summary.mode === 'satex_cases'
            ? (
              summary.satexScenario
                ? summary.satexScenario.label + ' · one submitted container'
                : 'Approved Satex scenario required'
            )
            : summary.capacity + ' pallets = 1 container'
        ) + '</small>' +
        (errors.length
          ? '<div class="smj-order-rule-errors">' +
              errors.map(escapeHtml).join('<br>') + '</div>'
          : '') +
      '</div>';
  }

  function applyCartRuleState(cart) {
    var summary = summarizeCart(cart || {});
    var errors = cartRuleErrors(cart || {}, summary);
    renderDrawerSummary(summary, errors);
    document.querySelectorAll('#checkout-button, #smj-confirm-order').forEach(function (button) {
      button.setAttribute('data-smj-order-valid', errors.length ? 'false' : 'true');
      button.classList.toggle('disabled', errors.length > 0);
    });
    var errorHost = document.getElementById('cart-validation-error');
    if (errorHost && errors.length) {
      errorHost.textContent = errors.join(' ');
      errorHost.style.display = 'block';
      errorHost.setAttribute('data-smj-rule-error', 'true');
    } else if (
      errorHost &&
      errorHost.getAttribute('data-smj-rule-error') === 'true'
    ) {
      errorHost.style.display = 'none';
      errorHost.removeAttribute('data-smj-rule-error');
    }
    return errors;
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('#checkout-button, #smj-confirm-order');
    if (!checkout || checkout.getAttribute('data-smj-order-valid') !== 'false') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var errorHost = document.getElementById('cart-validation-error');
    if (errorHost) {
      errorHost.style.display = 'block';
      errorHost.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  window.smjSummarizeCart = summarizeCart;
  window.smjCartRuleErrors = cartRuleErrors;
  window.smjApplyCartRuleState = applyCartRuleState;

  /* ---------- fill bar helper ---------- */
  function setFill(el, ratio) {
    if (!el) return;
    var span = el.querySelector('span');
    if (!span) return;
    var pct = Math.max(0, Math.min(1, ratio)) * 100;
    span.style.width = pct + '%';
    el.classList.toggle('is-complete', ratio >= 0.999 && ratio <= 1.001);
    el.classList.toggle('is-over', ratio > 1.001);
  }

  /* ---------- sticky container bar (collection) ---------- */
  function renderStickyBar(cart) {
    var bar = document.getElementById('smj-sticky-bar');
    if (!bar) return;
    var s = summarizeCart(cart);
    var count = bar.querySelector('[data-smj-count]');
    var status = bar.querySelector('[data-smj-status]');
    var fill = bar.querySelector('.smj-fill');

    if (s.mode === 'mixed_1l_20ft') {
      if (count) count.textContent = s.cases.toLocaleString() + ' cases · ' + formatMoney(s.totalPrice);
      if (status) status.textContent = s.mixed20ftComplete
        ? '20ft container complete'
        : s.cases.toLocaleString() + ' / ' + s.capacity.toLocaleString() + ' cases';
      setFill(fill, s.cases / s.capacity);
    } else if (s.mode === 'satex_cases') {
      var target = s.satexTargetCases || 1;
      if (count) count.textContent = s.cases.toLocaleString() + ' cases · ' + formatMoney(s.totalPrice);
      if (status) {
        status.textContent = !s.satexScenario
          ? 'Approved container scenario required'
          : s.satexScenarioComplete && !s.satexMixedWithPallets
          ? '1 container complete'
          : s.satexScenario.label + ': ' +
            s.satexOneLitreCases.toLocaleString() + '/' +
            Number(s.satexScenario.oneLitreCases).toLocaleString() + ' 1L · ' +
            s.satexTwoHundredMlCases.toLocaleString() + '/' +
            Number(s.satexScenario.twoHundredMlCases).toLocaleString() + ' 200ml';
      }
      setFill(fill, s.cases / target);
    } else {
      if (count) count.textContent = s.pallets.toLocaleString() + ' ' + (s.profile === 'case_pallet_22' ? 'plt (' + s.cases.toLocaleString() + ' cases)' : 'pallets') + ' · ' + formatMoney(s.totalPrice);
      if (status) status.textContent = s.pallets + ' / ' + s.capacity + ' pallets · ' + formatCount(s.containers) + ' container';
      setFill(fill, s.pallets / s.capacity);
    }
    var visible = s.itemCount > 0;
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('smj-has-sticky-bar', visible);
  }

  /* ---------- cart page summary card ---------- */
  function renderCartSummary(cart) {
    var host = document.getElementById('smj-cart-summary');
    if (!host) return;
    var s = summarizeCart(cart);
    var stateHtml = '';
    var fillRatio = 0;
    var headline = '';

    if (s.mode === 'mixed_1l_20ft') {
      fillRatio = s.cases / s.capacity;
      headline =
        '<div class="smj-summary-row"><span>20ft container cases</span><b>' +
          s.cases.toLocaleString() + ' / ' + s.capacity.toLocaleString() + '</b></div>' +
        '<div class="smj-summary-row"><span>Containers</span><b>' +
          formatCount(s.containers) + '</b></div>';
      if (s.mixed20ftMixedWithOtherItems) {
        stateHtml = '<div class="smj-summary-state is-bad">Submit this 20ft case container separately from pallet products.</div>';
      } else if (s.mixed20ftComplete) {
        stateHtml = '<div class="smj-summary-state is-good">One 20ft container complete · ready to submit.</div>';
      } else if (s.cases < s.capacity) {
        stateHtml = '<div class="smj-summary-state is-warn">' +
          (s.capacity - s.cases).toLocaleString() + ' cases remaining.</div>';
      } else {
        stateHtml = '<div class="smj-summary-state is-bad">Remove ' +
          (s.cases - s.capacity).toLocaleString() + ' cases to return to one container.</div>';
      }
    } else if (s.mode === 'satex_cases') {
      var complete = s.satexScenarioComplete && !s.satexMixedWithPallets;
      fillRatio = s.satexTargetCases ? s.cases / s.satexTargetCases : 0;
      headline =
        '<div class="smj-summary-row"><span>Scenario</span><b>' +
          escapeHtml(s.satexScenario ? s.satexScenario.label : 'Not selected') +
        '</b></div>' +
        '<div class="smj-summary-row"><span>1L cases</span><b>' +
          s.satexOneLitreCases.toLocaleString() +
          (s.satexScenario ? ' / ' + Number(s.satexScenario.oneLitreCases).toLocaleString() : '') +
        '</b></div>' +
        '<div class="smj-summary-row"><span>200ml cases</span><b>' +
          s.satexTwoHundredMlCases.toLocaleString() +
          (s.satexScenario ? ' / ' + Number(s.satexScenario.twoHundredMlCases).toLocaleString() : '') +
        '</b></div>' +
        '<div class="smj-summary-row"><span>Total cases</span><b>' +
          s.cases.toLocaleString() +
        '</b></div>';
      if (complete) {
        stateHtml = '<div class="smj-summary-state is-good">Container complete · ready to submit as one order.</div>';
      } else if (s.satexMixedWithPallets) {
        stateHtml = '<div class="smj-summary-state is-bad">A Satex tetra container cannot include pallet products. Submit them as a separate order.</div>';
      } else if (!s.satexScenario) {
        stateHtml = '<div class="smj-summary-state is-bad">This cart is missing an approved scenario. Rebuild it in the container planner.</div>';
      } else {
        stateHtml = '<div class="smj-summary-state is-warn">Complete both category targets shown above before checkout.</div>';
      }
    } else {
      fillRatio = s.pallets / s.capacity;
      var caseRow = s.cases > 0 ? '<div class="smj-summary-row"><span>Cases total</span><b>' + s.cases.toLocaleString() + '</b></div>' : '';
      headline = '<div class="smj-summary-row"><span>Total pallets</span><b>' + s.pallets.toLocaleString() + '</b></div>' +
        '<div class="smj-summary-row"><span>Containers (' + s.capacity + ' pallets each)</span><b>' +
          formatCount(s.containers) + '</b></div>' + caseRow;
      if (s.pallets === s.capacity) {
        stateHtml = '<div class="smj-summary-state is-good">1 full container · ' + s.capacity + ' pallets.</div>';
      } else if (s.pallets > s.palletLimit && s.profile !== 'case_pallet_22') {
        stateHtml = '<div class="smj-summary-state is-bad">Order exceeds ' + s.palletLimit + ' pallets — excess is removed automatically.</div>';
      } else if (s.pallets > s.capacity) {
        stateHtml = '<div class="smj-summary-state is-good">' + formatCount(s.containers) +
          ' containers · fractional containers are shown without rounding up.</div>';
      } else if (s.pallets > 0) {
        stateHtml = '<div class="smj-summary-state is-warn">' + (s.capacity - s.pallets) + ' pallets to a full container (' + s.capacity + ' = 1 container).</div>';
      }
    }

    /* container split display (e.g. 33 pallets = 1 full + 11/22) */
    var splitHtml = '';
    if (
      s.mode !== 'satex_cases' &&
      s.mode !== 'mixed_1l_20ft' &&
      s.pallets > s.capacity
    ) {
      var full = Math.floor(s.pallets / s.capacity);
      var rest = s.pallets % s.capacity;
      splitHtml = '<div class="smj-split">';
      for (var i = 0; i < Math.min(full, 4); i++) {
        splitHtml += '<div class="smj-split-row"><span class="smj-split-tag">Container ' + (i + 1) + '</span><div class="smj-fill is-complete"><span style="width:100%"></span></div><span>' + s.capacity + '/' + s.capacity + '</span></div>';
      }
      if (rest > 0) {
        splitHtml += '<div class="smj-split-row"><span class="smj-split-tag">Container ' + (full + 1) + '</span><div class="smj-fill"><span style="width:' + Math.round((rest / s.capacity) * 100) + '%"></span></div><span>' + rest + '/' + s.capacity + '</span></div>';
      }
      splitHtml += '</div>';
    }

    var attrs = cart.attributes || {};
    var po = attrs['PO Number'] || '';
    var sail = attrs['Requested Sail Date'] || '';

    host.innerHTML =
      '<div class="smj-summary-card">' +
        '<h3>Container summary</h3>' +
        headline +
        '<div class="smj-fill"><span></span></div>' +
        stateHtml +
        splitHtml +
        '<div class="smj-summary-row"><span>Subtotal</span><b>' + formatMoney(s.totalPrice) + '</b></div>' +
        '<div class="smj-summary-field"><label for="smj-po">PO Number <span class="smj-req">*</span></label>' +
        '<input type="text" id="smj-po" placeholder="Enter PO number" value="' + String(po).replace(/"/g, '&quot;') + '"></div>' +
        '<div class="smj-summary-field"><label for="smj-sail">Requested sail date <span class="smj-req">*</span></label>' +
        '<input type="date" id="smj-sail" value="' + String(sail).replace(/"/g, '&quot;') + '"></div>' +
        '<p class="smj-summary-note">* Sea freight, pallet cost, insurance &amp; documentation added at invoice stage.</p>' +
        '<a href="/checkout" id="smj-confirm-order" class="smj-btn smj-btn--cyan">Confirm order</a>' +
      '</div>';

    setFill(host.querySelector('.smj-fill'), fillRatio);

    var poInput = host.querySelector('#smj-po');
    var sailInput = host.querySelector('#smj-sail');
    if (poInput) poInput.addEventListener('change', function () {
      if (window.CartJS) window.CartJS.setAttribute('PO Number', this.value);
      var drawer = document.getElementById('po-number');
      if (drawer) drawer.value = this.value;
    });
    if (sailInput) sailInput.addEventListener('change', function () {
      if (window.CartJS) window.CartJS.setAttribute('Requested Sail Date', this.value);
      var drawer = document.getElementById('requested-sail-date');
      if (drawer) drawer.value = this.value;
    });
    syncConfirmState();
  }

  /* per-line "= N cases" under the qty stepper (design 1A cart) */
  function annotateCartCases(cart) {
    var table = document.querySelector('.smj-cart-main table.cart-table');
    var map = window.smjCartCpp;
    if (!table || !map || !cart.items) return;
    var isCaseUnit = (cfg().unit || 'pallets') === 'cases';
    table.querySelectorAll('tbody tr').forEach(function (row, i) {
      var item = cart.items[i];
      if (!item) return;
      var cell = row.querySelector('.cart-qty-selector');
      if (!cell) return;
      var note = cell.querySelector('.smj-line-cases');
      var cpp = parseInt(map[String(item.variant_id)], 10) || 0;
      var text = '';
      if (cpp > 1) {
        text = isCaseUnit
          ? '= ' + formatCount(Math.ceil(item.quantity / cpp)) + ' plt'
          : '= ' + (item.quantity * cpp).toLocaleString() + ' cases';
      }
      if (!note) {
        note = document.createElement('div');
        note.className = 'smj-line-cases';
        cell.appendChild(note);
      }
      note.textContent = text;
    });
  }

  /* keep our confirm button in step with the existing #checkout-button state
     so all live validation still decides whether checkout is allowed */
  function syncConfirmState() {
    var source = document.getElementById('checkout-button');
    var target = document.getElementById('smj-confirm-order');
    if (!source || !target) return;
    target.classList.toggle('is-disabled', source.classList.contains('disabled'));
  }
  function watchCheckoutButton() {
    var source = document.getElementById('checkout-button');
    if (!source || !window.MutationObserver) return;
    new MutationObserver(syncConfirmState).observe(source, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- generic steppers (.smj-stepper [data-step]) ---------- */
  function bindSteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.smj-stepper [data-step]');
      if (!btn) return;
      e.preventDefault();
      var input = btn.closest('.smj-stepper').querySelector('input');
      if (!input) return;
      var step = parseInt(input.getAttribute('data-step-amount'), 10) ||
        parseInt(input.getAttribute('step'), 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || 0;
      var max = parseInt(input.getAttribute('max'), 10) || Infinity;
      var val = parseInt(input.value, 10) || 0;
      val += btn.getAttribute('data-step') === 'plus' ? step : -step;
      input.value = Math.max(min, Math.min(max, val));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- quick-order table (1B) ---------- */
  function initQuickOrder() {
    var table = document.getElementById('smj-qo-table');
    if (!table) return;
    var footer = document.getElementById('smj-qo-footer');
    var capacity = cfg().capacity || 22;
    function recalc() {
      var cases = 0, pallets = 0, subtotal = 0;
      var invalid = false;
      table.querySelectorAll('tr[data-smj-row]').forEach(function (row) {
        var input = row.querySelector('.smj-qo-qty');
        var cpp = parseInt(row.getAttribute('data-cpp'), 10) || 1;
        var price = parseInt(row.getAttribute('data-price'), 10) || 0; /* cents per unit (case or pallet) */
        var qty = parseInt(input && input.value, 10) || 0;
        var rowMode = row.getAttribute('data-mode') || table.getAttribute('data-mode') || 'pallets';
        var casesMode = rowMode === 'cases';
        var rowProperties = {};
        try {
          rowProperties = JSON.parse(row.getAttribute('data-properties') || '{}');
        } catch (error) {
          rowProperties = {};
        }
        var satexMode = rowProperties._smj_order_profile === 'satex_case_2500' ||
          row.getAttribute('data-profile') === 'satex_case_2500';
        var convCell = row.querySelector('.smj-qo-pallets');
        var totalCell = row.querySelector('.smj-qo-line-total');
        var warnRow = row.nextElementSibling && row.nextElementSibling.classList.contains('smj-qo-warning') ? row.nextElementSibling : null;
        var isPartial = casesMode && !satexMode && qty > 0 && qty % cpp !== 0;
        var rowPallets = satexMode ? 0 : casesMode ? qty / cpp : qty;
        var rowCases = casesMode ? qty : qty * cpp;

        if (convCell) {
          convCell.textContent = qty > 0
            ? (satexMode
              ? 'Use Build container'
              : casesMode
                ? formatCount(rowPallets) + (isPartial ? ' partial' : '') + ' pallets'
                : rowCases.toLocaleString() + ' cases')
            : '—';
          convCell.classList.toggle('is-partial', isPartial);
        }
        if (totalCell) totalCell.textContent = qty > 0 ? formatMoney(qty * price) : '—';
        if (warnRow) {
          warnRow.style.display = isPartial ? '' : 'none';
          var warnCell = warnRow.querySelector('td');
          if (warnCell && isPartial) {
            var missing = cpp - (qty % cpp);
            warnCell.textContent = qty.toLocaleString() + ' cases = ' + formatCount(rowPallets) +
              ' pallets (partial). Add ' + missing + ' cases to complete pallet ' + Math.ceil(rowPallets) +
              ' — orders must be in multiples of ' + cpp + ' cases.';
          }
        }
        cases += rowCases;
        if (!satexMode) pallets += qty > 0 ? Math.ceil(rowPallets) : 0;
        if (satexMode && qty > 0) invalid = true;
        if (isPartial) invalid = true;
        subtotal += qty * price;
      });

      if (footer) {
        footer.querySelector('[data-qo-cases]').textContent = cases.toLocaleString();
        footer.querySelector('[data-qo-pallets]').textContent = formatCount(pallets);
        footer.querySelector('[data-qo-containers]').textContent = formatCount(pallets / capacity);
        footer.querySelector('[data-qo-subtotal]').textContent = formatMoney(subtotal);
        setFill(footer.querySelector('.smj-fill'), pallets / capacity);
      }
      var addButton = document.getElementById('smj-qo-add-all');
      if (addButton) addButton.classList.toggle('is-disabled', invalid);
      table.setAttribute('data-order-valid', invalid ? 'false' : 'true');
    }

    table.addEventListener('input', function (e) {
      if (e.target.classList.contains('smj-qo-qty')) recalc();
    });
    table.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-smj-qo-group-toggle]');
      if (!toggle) return;
      e.preventDefault();
      var group = toggle.closest('.smj-qo-group');
      if (!group) return;
      var collapsed = group.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
    table.addEventListener('smj:quick-order:hydrated', recalc);

    var addAll = document.getElementById('smj-qo-add-all');
    if (addAll) addAll.addEventListener('click', function (e) {
      e.preventDefault();
      if (table.getAttribute('data-order-valid') === 'false') return;
      var items = [];
      table.querySelectorAll('tr[data-smj-row]').forEach(function (row) {
        var qty = parseInt(row.querySelector('.smj-qo-qty') && row.querySelector('.smj-qo-qty').value, 10) || 0;
        var variantId = parseInt(row.getAttribute('data-variant'), 10);
        var cpp = parseInt(row.getAttribute('data-cpp'), 10) || 1;
        if (qty > 0 && variantId) {
          var item = { id: variantId, quantity: qty };
          var properties = {};
          try {
            properties = JSON.parse(row.getAttribute('data-properties') || '{}');
          } catch (error) {
            properties = {};
          }
          var rowCasesMode = (row.getAttribute('data-mode') || table.getAttribute('data-mode')) === 'cases';
          if (Object.keys(properties).length) {
            item.properties = properties;
          } else if (rowCasesMode) {
            /* same properties the product page sets for case-profile customers */
            if (row.getAttribute('data-profile') !== 'satex_case_2500') {
              item.properties = {
                _smj_case_order: 'true',
                _smj_cases_per_pallet: String(cpp),
                _smj_order_unit: 'cases',
                _smj_order_profile: 'case_pallet_22',
                _smj_container_capacity: '22',
                _smj_container_unit: 'pallets'
              };
            }
          }
          /* pallets mode: plain quantity, exactly like the live grid add-to-cart */
          items.push(item);
        }
      });
      if (!items.length) return;
      addAll.classList.add('is-disabled');
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () {
        if (window.CartJS) window.CartJS.getCart();
        window.location.href = '/cart';
      }).catch(function () {
        addAll.classList.remove('is-disabled');
      });
    });

    recalc();
  }

  /* ---------- container planner (1C) ---------- */
  function initPlanner() {
    var list = document.getElementById('smj-planner-list');
    if (!list) return;

    function isMixed20ftPlanner() {
      return list.getAttribute('data-planner-mode') === 'mixed_1l_20ft';
    }

    function selectedScenario() {
      if (isMixed20ftPlanner()) {
        return {
          key: 'mixed_1l_20ft',
          label: '20ft mixed 1L container',
          oneLitreCases: mixed20ftCapacity(),
          twoHundredMlCases: 0
        };
      }
      var selected = document.querySelector('[data-smj-scenario]:checked');
      return selected ? satexScenarioByKey(selected.value) : null;
    }

    function categoryTarget(scenario, category) {
      if (!scenario) return 0;
      return category === 'one_litre'
        ? Number(scenario.oneLitreCases)
        : Number(scenario.twoHundredMlCases);
    }

    function plannerInputs() {
      return list.querySelectorAll('.smj-planner-row[data-eligible] input');
    }

    function applyScenarioState(reset) {
      var scenario = selectedScenario();
      plannerInputs().forEach(function (input) {
        var row = input.closest('.smj-planner-row');
        var category = row ? row.getAttribute('data-category') : '';
        input.disabled = !scenario;
        input.max = scenario ? String(categoryTarget(scenario, category)) : '0';
        if (reset) input.value = '0';
      });
      recalc();
    }

    function recalc() {
      var scenario = selectedScenario();
      var total = 0;
      var oneLitreTotal = 0;
      var twoHundredMlTotal = 0;
      var itemsHtml = '';
      plannerInputs().forEach(function (input) {
        var qty = parseInt(input.value, 10) || 0;
        var row = input.closest('.smj-planner-row');
        var category = row ? row.getAttribute('data-category') : '';
        total += qty;
        if (category === 'one_litre') oneLitreTotal += qty;
        if (category === 'two_hundred_ml') twoHundredMlTotal += qty;
        if (qty > 0) {
          var name = row.getAttribute('data-name') || '';
          itemsHtml += '<div class="smj-rail-item"><span>' +
            escapeHtml(name) + '</span><b>' + qty.toLocaleString() + '</b></div>';
        }
      });
      var target = satexScenarioTotal(scenario);
      var complete = !!(
        scenario &&
        oneLitreTotal === Number(scenario.oneLitreCases) &&
        twoHundredMlTotal === Number(scenario.twoHundredMlCases)
      );
      var pct = target
        ? Math.min(100, Math.round((total / target) * 100))
        : 0;

      var ring = document.getElementById('smj-ring');
      if (ring) {
        ring.style.background = 'conic-gradient(' + (complete ? '#2e9e54' : 'var(--smj-cyan)') + ' ' + (pct * 3.6) + 'deg, var(--smj-line) 0deg)';
        var pctEl = ring.querySelector('b');
        if (pctEl) pctEl.textContent = pct + '%';
      }
      var sub = document.getElementById('smj-rail-sub');
      if (sub) {
        sub.innerHTML = isMixed20ftPlanner()
          ? complete
            ? '<b>' + mixed20ftCapacity().toLocaleString() + ' cases</b> · one 20ft container complete'
            : '<b>' + total.toLocaleString() + ' / ' + mixed20ftCapacity().toLocaleString() + ' cases</b>' +
              '<span class="smj-rail-target">' +
                Math.max(mixed20ftCapacity() - total, 0).toLocaleString() +
                ' cases remaining</span>'
          : !scenario
          ? '<b>Select a scenario</b> to unlock eligible quantities'
          : complete
            ? '<b>' + total.toLocaleString() + '</b> cases · one container complete'
            : '<b>' + escapeHtml(scenario.label) + '</b>' +
              '<span class="smj-rail-target">1L: ' +
                oneLitreTotal.toLocaleString() + ' / ' +
                Number(scenario.oneLitreCases).toLocaleString() +
              '</span>' +
              '<span class="smj-rail-target">200ml: ' +
                twoHundredMlTotal.toLocaleString() + ' / ' +
                Number(scenario.twoHundredMlCases).toLocaleString() +
              '</span>';
      }
      var itemsHost = document.getElementById('smj-rail-items');
      if (itemsHost) itemsHost.innerHTML = itemsHtml || '<div class="smj-rail-item"><span>No eligible cases yet</span></div>';
      var lock = document.getElementById('smj-planner-lock');
      if (lock) {
        lock.classList.toggle('is-disabled', !complete);
        lock.innerHTML = complete
          ? (isMixed20ftPlanner() ? 'Add 20ft container' : 'Lock container') +
            '<span class="smj-lock-count"> (' + total.toLocaleString() + ' cases)</span>'
          : scenario
            ? 'Complete both targets'
            : 'Select a scenario';
      }
    }

    list.addEventListener('input', function (e) {
      if (!e.target.matches('.smj-planner-row input')) return;
      var scenario = selectedScenario();
      if (!scenario) {
        e.target.value = '0';
        recalc();
        return;
      }
      var current = parseInt(e.target.value, 10) || 0;
      var otherTotal = 0;
      var row = e.target.closest('.smj-planner-row');
      var category = row ? row.getAttribute('data-category') : '';
      plannerInputs().forEach(function (input) {
        var otherRow = input.closest('.smj-planner-row');
        if (
          input !== e.target &&
          otherRow &&
          otherRow.getAttribute('data-category') === category
        ) {
          otherTotal += parseInt(input.value, 10) || 0;
        }
      });
      e.target.value = Math.max(
        0,
        Math.min(current, categoryTarget(scenario, category) - otherTotal)
      );
      recalc();
    });
    list.addEventListener('smj:planner:hydrated', function () {
      applyScenarioState(false);
    });
    document.querySelectorAll('[data-smj-scenario]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        applyScenarioState(true);
      });
    });

    var lock = document.getElementById('smj-planner-lock');
    if (lock) lock.addEventListener('click', function (e) {
      e.preventDefault();
      if (lock.classList.contains('is-disabled')) return;
      var scenario = selectedScenario();
      if (!scenario) return;
      var scenarioTotal = satexScenarioTotal(scenario);
      var items = [];
      list.querySelectorAll('.smj-planner-row[data-eligible]').forEach(function (row) {
        var qty = parseInt(row.querySelector('input') && row.querySelector('input').value, 10) || 0;
        var variantId = parseInt(row.getAttribute('data-variant'), 10);
        var category = row.getAttribute('data-category') || '';
        if (qty > 0 && variantId) {
          var properties = {};
          try {
            properties = JSON.parse(row.getAttribute('data-properties') || '{}');
          } catch (error) {
            properties = {};
          }
          var scenarioProperties = isMixed20ftPlanner()
            ? {
              _smj_case_order: 'true',
              _smj_order_unit: 'cases',
              _smj_order_profile: 'mixed_1l_20ft',
              _smj_container_capacity: String(mixed20ftCapacity()),
              _smj_container_unit: 'cases',
              _smj_container_size: '20ft'
            }
            : {
              _smj_case_order: 'true',
              _smj_order_unit: 'cases',
              _smj_order_profile: 'satex_case_2500',
              _smj_container_capacity: String(scenarioTotal),
              _smj_container_unit: 'cases',
              _smj_satex_scenario: scenario.key,
              _smj_satex_category: category,
              _smj_satex_1l_target: String(scenario.oneLitreCases),
              _smj_satex_200ml_target: String(scenario.twoHundredMlCases)
            };
          Object.keys(scenarioProperties).forEach(function (key) {
            properties[key] = scenarioProperties[key];
          });
          items.push({
            id: variantId,
            quantity: qty,
            properties: properties
          });
        }
      });
      if (!items.length) return;
      lock.classList.add('is-disabled');
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (cart.item_count > 0) {
            throw new Error('cart_not_empty');
          }
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('cart_add_failed');
          if (window.CartJS) window.CartJS.getCart();
          window.location.href = '/cart';
        }).catch(function (error) {
          var sub = document.getElementById('smj-rail-sub');
          if (sub && error.message === 'cart_not_empty') {
            sub.innerHTML = '<b>Review or clear the current cart before locking this container.</b>';
          }
          lock.classList.remove('is-disabled');
        });
    });

    applyScenarioState(false);
  }

  /* ---------- reorder review sheet (3a) ---------- */
  function initReorder() {
    var wrap = document.getElementById('smj-orders');
    if (!wrap) return;
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-reorder-toggle]');
      if (btn) {
        e.preventDefault();
        var sheet = document.getElementById(btn.getAttribute('data-reorder-toggle'));
        if (sheet) sheet.classList.toggle('is-open');
      }
      var add = e.target.closest('[data-reorder-add]');
      if (add) {
        e.preventDefault();
        var items = [];
        try { items = JSON.parse(add.getAttribute('data-reorder-add')) || []; } catch (err) { items = []; }
        if (!items.length) return;
        add.classList.add('is-disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function () {
          add.classList.remove('is-disabled');
        });
      }
    });
  }

  /* ---------- catalog search (1A toolbar) ---------- */
  function initCatalogSearch() {
    var input = document.getElementById('smj-catalog-search');
    if (!input) return;
    input.addEventListener('input', function () {
      var q = this.value.toLowerCase().trim();
      document.querySelectorAll('#smj-collection-product-grid .smj-card').forEach(function (card) {
        var match = !q || (card.getAttribute('data-smj-title') || '').indexOf(q) !== -1;
        var col = card.parentElement;
        (col && col.className.indexOf('col-') !== -1 ? col : card).style.display = match ? '' : 'none';
      });
    });
  }

  /* ---------- announce bar + login toast (2a) ---------- */
  function initAnnounce() {
    var bar = document.getElementById('smj-announce');
    if (bar) {
      try {
        if (sessionStorage.getItem('smj_announce_dismissed') === '1') bar.style.display = 'none';
      } catch (e) { /* noop */ }
      var close = bar.querySelector('.smj-announce-close');
      if (close) close.addEventListener('click', function () {
        bar.style.display = 'none';
        try { sessionStorage.setItem('smj_announce_dismissed', '1'); } catch (e) { /* noop */ }
      });
    }
    var toast = document.getElementById('smj-toast');
    if (toast && cfg().loggedIn) {
      var shown = false;
      try { shown = sessionStorage.getItem('smj_launch_toast') === '1'; } catch (e) { /* noop */ }
      if (!shown) {
        setTimeout(function () { toast.classList.add('is-visible'); }, 1200);
        try { sessionStorage.setItem('smj_launch_toast', '1'); } catch (e) { /* noop */ }
      }
      var tClose = toast.querySelector('.smj-toast-close');
      if (tClose) tClose.addEventListener('click', function () { toast.classList.remove('is-visible'); });
    }
  }

  /* ---------- Shopify preview-bar offset ----------
     On theme-preview links Shopify injects a fixed bottom bar that covers
     our bottom-fixed UI (sticky bar, planner rail, quick-order footer).
     Measure it and offset via CSS var; 0 on the published theme. */
  function offsetForPreviewBar() {
    var bar = document.getElementById('PBarNextFrameWrapper') ||
              document.getElementById('PBarNextFrame') ||
              document.getElementById('preview-bar-iframe') ||
              document.querySelector('iframe[src*="preview_bar"]');
    var h = 0;
    if (bar) {
      var r = bar.getBoundingClientRect();
      if (r.height > 0 && r.bottom >= window.innerHeight - 4) h = Math.round(r.height);
    }
    document.documentElement.style.setProperty('--smj-preview-offset', h + 'px');
  }

  /* ---------- boot ---------- */
  function onCartUpdate(cart) {
    renderStickyBar(cart);
    renderCartSummary(cart);
    window.setTimeout(function () {
      applyCartRuleState(cart);
      syncConfirmState();
    }, 30);
    /* Rivets re-renders rows async — annotate after it settles */
    setTimeout(function () { annotateCartCases(cart); }, 60);
  }

  function boot() {
    bindSteppers();
    initQuickOrder();
    initPlanner();
    initReorder();
    initAnnounce();
    initCatalogSearch();
    watchCheckoutButton();
    offsetForPreviewBar();
    setTimeout(offsetForPreviewBar, 1500);
    window.addEventListener('resize', offsetForPreviewBar);

    if (window.jQuery && window.CartJS) {
      window.jQuery(document).on('cart.requestComplete', function (event, cart) {
        onCartUpdate(cart || (window.CartJS && window.CartJS.cart) || {});
      });
      if (window.CartJS.cart) onCartUpdate(window.CartJS.cart);
    }
    /* fallback for first paint before CartJS init */
    fetch('/cart.js').then(function (r) { return r.json(); }).then(onCartUpdate).catch(function () { /* noop */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
